import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		themes: {
			light: {
				primary: "#8b4eda",
				secondary: "#ffb946",
				accent: "#109cf1",
				info: "#2196F3",
				success: "#81CC00",
				error: "#FF5252",
				warning: "#FFC107",
			}
		}
	},
	icons: {
		iconfont: "mdi"
	}
});
